// OsdLueckentextData.js
export const lueckenTextFull = {
    title: "Weltweit nimmt die Zahl der Übergewichtigen zu",
    parts: [
        { id: 1, text: "London. Der Anteil übergewichtiger Kin", correct: "der" },
        { id: 2, text: " weltweit wird nach Einschätzungen v", correct: "on" },
        { id: 3, text: " Experten in den kommenden Jahren drasti", correct: "sch" },
        { id: 4, text: " ansteigen. In Nord- und Südamerika wi", correct: "rd" },
        { id: 5, text: " bald die Hälfte der Jungen und Mädchen z", correct: "u" },
        { id: 6, text: " dick sein, wie aus einer kürzlich veröff", correct: "ent" },
        { id: 7, text: " lichten Studie hervorgeht. Sollte sich ", correct: "der" },
        { id: 8, text: " Trend fortsetzen, könnte der Anteil ", correct: "in" },
        { id: 9, text: " der EU demnach bei 38 Prozent liegen. „Wir haben wirklich eine globale Epidem", correct: "ie" },
        { id: 10, text: " die anscheinend die meisten Länder auf ", correct: "der" },
        { id: 11, text: " Welt betrifft“, sagt Philipp James, Dir", correct: "ek" },
        { id: 12, text: " tor des internationalen Forschun", correct: "gs" },
        { id: 13, text: " netzwerkes IOTF. Die beteiligten Wissenschaft", correct: "ler" },
        { id: 14, text: " führen diese Entwicklung unter ander", correct: "em" },
        { id: 15, text: " auf ungesunde Ernährung und zu we", correct: "nig" },
        { id: 16, text: " Bewegung zurück. Speziell Fastfood gerät im", correct: "mer" },
        { id: 17, text: " mehr unter Kritik. Ein Beispiel lief", correct: "ert" },
        { id: 18, text: " die Situation in Japan, wo statt Fisch ", correct: "und" },
        { id: 19, text: " Reis immer häufiger Hamburger und Pom", correct: "mes" },
        { id: 20, text: " frites gegessen werden. Die Folgen si", correct: "nd" }
    ],
    ending: " besonders bei Kindern sichtbar."
};